module.exports = __webpack_public_path__ + "static/media/qrlogo.a59aaca2.svg";